"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultCategory = void 0;
var ResultCategory;
(function (ResultCategory) {
    ResultCategory["whoAreYou"] = "whoAreYou";
    ResultCategory["byTheNumbers"] = "byTheNumbers";
    ResultCategory["loveAndRelationships"] = "loveAndRelationships";
    ResultCategory["workAndPurpose"] = "workAndPurpose";
    ResultCategory["lifesyleAndBeliefs"] = "lifestyleAndBeliefs";
    ResultCategory["personalDevelopment"] = "personalDevelopment";
    ResultCategory["howOthersSeeYou"] = "howOthersSeeYou";
    ResultCategory["justForFun"] = "justForFun";
    ResultCategory["recommendations"] = "recommendations";
})(ResultCategory = exports.ResultCategory || (exports.ResultCategory = {}));
